import {DropdownItemCheckbox} from "@atlaskit/dropdown-menu";
import type {ComponentProps} from "react";

export function AnankeDropdownItemCheckbox(props: ComponentProps<typeof DropdownItemCheckbox>) {
    return <DropdownItemCheckbox {...props} />;
}
